import Axios from 'axios';
import { URIs } from '../../src_server/common/URIs';
import { FileType } from '../../src_server/param/UploadParam';
export class FileUpload {
  private _uploadedImage?: ArrayBuffer;
  get uploadedImage(): ArrayBuffer {
    if (!this._uploadedImage) {
      return new ArrayBuffer(0);
    }
    return this._uploadedImage;
  }

  async fileUpload(user_id: string, type: FileType, data: File): Promise<string> {
    console.log('fileUpload : ', typeof data);

    const headers = { 'content-type': 'multipart/form-data' };
    const form = new FormData();
    form.set('file', data);

    console.log('upload before in file ', user_id, type, form);
    const path = URIs.FILE_UP.setQuery({
      user_id: user_id,
      type: type,
    }).path;
    console.log(path);
    const post = await Axios.post<any>(path, form, { headers: headers });
    console.log({ post });
    return post.data.data;
  }
}
